import { useCallback } from 'react'

import type { PlateElementProps } from 'platejs/react'

import {
  EditorTooltip,
  TooltipButton,
} from '~publish/legacy/editor/components/EditorTooltip'

import styles from './styles.module.css'
import { LinkElement } from '../nodes/LinkElement'

type LinkElementUIProps = PlateElementProps<LinkElement>

export const LinkElementUI = (props: LinkElementUIProps): JSX.Element => {
  const { attributes, children, element } = props

  const href = LinkElement.getHref(element)
  const onOpenClick = useCallback(() => {
    window.open(href, '_blank')
  }, [href])

  return (
    <span {...attributes} className={styles.wrapper}>
      <EditorTooltip trigger={<span>{children}</span>}>
        <TooltipButton onClick={onOpenClick}>Open Link</TooltipButton>
      </EditorTooltip>
    </span>
  )
}
